import React from 'react'
import { Component } from 'react'
import Constantes from '../php/Constantes';

class Alertas extends Component {
    constructor(props){
        super(props);
        this.state = {
            mostrarAlerta: false,
        }
    }


    async componentDidMount(){
        const cargaUtil = JSON.stringify([sessionStorage.lugar,sessionStorage.lugarCentral]);
        const respuesta = await fetch(`${Constantes.RUTA_API}/verificar_alertas.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const datos = await respuesta.json();
        if((datos) && (datos === 'si')){
            this.setState({
                mostrarAlerta: true,
            })
        }
    }

    render(){
        return (
            <>
                {this.state.mostrarAlerta ? (<div className='alert alert-danger' style={{textAlign:'center'}}> Tiene actividades pendientes </div>) : null}
            </>
        )//Final return
    }//Final Render
}

export default Alertas